import React, { memo, FC } from "react";
import { Alert, Typography } from "@mui/material";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { Image, Transformation } from "cloudinary-react";
import {
  screenLayoutImages,
  screenColors,
  singleScreenLayout,
  comboScreenLayout,
  layoutLeft,
  layoutRight,
  shadeColors,
  shadeLayout,
} from "../../initialValues/screens";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useScreenSelection from "./useScreenSelection";
import PleaseNote from "../PleaseNote";

const RowLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  padding: theme.spacing(1, 2),
  alignSelf: "flex-end",
  marginTop: 20,
}));

interface CentorScreenAccordionProps {
  width: number;
  widthRight: number;
}

const CentorScreenAccordian: FC<CentorScreenAccordionProps> = ({
  width,
  widthRight,
}) => {
  const {
    hasShade,
    displayedImage,
    handleClick,
    handleAddScreenClick,
    centor,
    screenColorChoice,
    screenLayout,
    shadeMeshColor,
    screenVal,
    isCornerUnit,
    oneDirectionConfig,
    widerThan16,
    theme,
    centorWidthSub,
    centorWidth,
    centorCushion,
    isScreenNotRequired
  } = useScreenSelection(width, widthRight);

  return (
    <ReusableAccordian
      //if bi fold door/window aluminum or bi fold combo, then use screeNotRequired accordion name so that the asterix is not displayed
      accordionName={isScreenNotRequired ? "screenNotRequired" : "screen"}
      heading="Centor Screen"
      secondaryHeading="Select Screen Option"
    >
      {isCornerUnit &&
      (widerThan16 || widthRight - centorWidthSub - centorCushion > 181) ? (
        <Alert severity="error">
          Centor Screens not available if width is greater than 182 inches
        </Alert>
      ) : !isCornerUnit && centorWidth > 354 ? (
        <Alert severity="error">
          Centor Screens not available if width is greater than 355 inches
        </Alert>
      ) : (
        <ColLayout>
          <PleaseNote notes="Up-charge applies to all screens/shades" />

          {!screenVal ? (
            <RowLayout>
              {centor.map((state) => (
                <div
                  key={state.id}
                  onClick={() => handleAddScreenClick(state.label)}
                >
                  <Choices
                    label={state.label}
                    variant={state.label === screenVal ? "filled" : "outlined"}
                    checkMark={state.label === screenVal}
                    wide={true}
                  />
                </div>
              ))}
            </RowLayout>
          ) : (
            <>
              <RowLayout>
                {centor.map((state) => (
                  <div
                    key={state.id}
                    onClick={() => handleAddScreenClick(state.label)}
                  >
                    <Choices
                      label={state.label}
                      variant={
                        state.label === screenVal ? "filled" : "outlined"
                      }
                      checkMark={state.label === screenVal}
                      wide={true}
                    />
                  </div>
                ))}
              </RowLayout>

              <RowLayout>
                {screenVal && !screenVal.includes("Double") && (
                  <ColLayout>
                    <Typography variant="subtitle1">
                      {screenVal === "Add Combo Screen/Shade" && "Combo "}
                      {screenVal === "Add Screen" && "Screen "}
                      {screenVal === "Add Shade" && "Shade "}
                        Layout
                      <span style={{ color: "red", fontSize: 22 }}>*</span>
                    </Typography>

                    <RowLayoutSpacing style={{ paddingTop: 0 }}>
                      {screenVal === "Add Combo Screen/Shade"
                        ? comboScreenLayout.map((state) => (
                            <div
                              key={state.id}
                              onClick={handleClick(
                                state.label,
                                screenLayout || "",
                                "screenLayout",
                                "Combo Layout",
                              )}
                            >
                              <Choices
                                label={state.label}
                                variant={
                                  (state.label.includes("Left Screen") &&
                                    screenLayout?.includes("Left Screen")) ||
                                  (state.label.includes("Right Screen") &&
                                    screenLayout?.includes("Right Screen"))
                                    ? "filled"
                                    : "outlined"
                                }
                                checkMark={
                                  (state.label.includes("Left Screen") &&
                                    screenLayout?.includes("Left Screen")) ||
                                  (state.label.includes("Right Screen") &&
                                    screenLayout?.includes("Right Screen"))
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          ))
                        : screenVal === "Add Shade" && !oneDirectionConfig
                          ? shadeLayout.map((state) => (
                              <div
                                key={state.id}
                                onClick={handleClick(
                                  state.label,
                                  screenLayout || "",
                                  "screenLayout",
                                  "Shade Layout",
                                )}
                              >
                                <Choices
                                  label={state.label}
                                  variant={
                                    state.label === screenLayout ||
                                    state.pdfLabel === screenLayout
                                      ? "filled"
                                      : "outlined"
                                  }
                                  checkMark={
                                    state.label === screenLayout ||
                                    state.pdfLabel === screenLayout
                                  }
                                />
                              </div>
                            ))
                          : screenVal === "Add Shade" &&
                              oneDirectionConfig[1] === "L"
                            ? shadeLayout
                                .filter((itm) => itm.label === "Left Shade")
                                .map((state) => (
                                  <div key={state.id}>
                                    <Choices
                                      label={state.label}
                                      variant="filled"
                                      checkMark={true}
                                    />
                                  </div>
                                ))
                            : screenVal === "Add Shade" &&
                                oneDirectionConfig[1] === "R"
                              ? shadeLayout
                                  .filter((itm) => itm.label === "Right Shade")
                                  .map((state) => (
                                    <div key={state.id}>
                                      <Choices
                                        label={state.label}
                                        variant="filled"
                                        checkMark={true}
                                      />
                                    </div>
                                  ))
                              : !oneDirectionConfig
                                ? singleScreenLayout.map((state) => (
                                    <div
                                      key={state.id}
                                      onClick={handleClick(
                                        state.label,
                                        screenLayout || "",
                                        "screenLayout",
                                        "Screen Layout",
                                      )}
                                    >
                                      <Choices
                                        label={state.label}
                                        variant={
                                          state.label === screenLayout ||
                                          state.pdfLabel === screenLayout
                                            ? "filled"
                                            : "outlined"
                                        }
                                        checkMark={
                                          state.label === screenLayout ||
                                          state.pdfLabel === screenLayout
                                        }
                                      />
                                    </div>
                                  ))
                                : oneDirectionConfig[1] === "L"
                                  ? layoutLeft.map((state) => (
                                      <div key={state.id}>
                                        <Choices
                                          label={state.label}
                                          variant="filled"
                                          checkMark={true}
                                        />
                                      </div>
                                    ))
                                  : oneDirectionConfig[1] === "R"
                                    ? layoutRight.map((state) => (
                                        <div key={state.id}>
                                          <Choices
                                            label={state.label}
                                            variant="filled"
                                            checkMark={true}
                                          />
                                        </div>
                                      ))
                                    : null}
                    </RowLayoutSpacing>
                  </ColLayout>
                )}

                {hasShade && (
                  <div
                    style={
                      screenVal === "Add Double Shade"
                        ? {
                            marginBottom: 10,
                            marginTop: 20,
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            padding: theme.spacing(1, 2),
                          }
                        : {
                            marginBottom: 10,
                            marginTop: 20,
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            borderLeft: `2px solid ${theme.palette.divider}`,
                            padding: theme.spacing(1, 2),
                          }
                    }
                  >
                    <Typography variant="subtitle1">
                       {/* {screenVal === "Add Combo Screen/Shade" && "Combo "}
                      {(screenVal === "Add Shade" || screenVal === "Add Double Shade") && "Shade "} */}
                      Shade Mesh Color
                      <span style={{ color: "red", fontSize: 22 }}>*</span>
                    </Typography>

                    <RowLayout>
                      {shadeColors.map((state) => (
                        <div
                          key={state.id}
                          onClick={handleClick(
                            state.label,
                            shadeMeshColor || "",
                            "shadeMeshColor",
                            "Shade Mesh Color"
                            // `${screenVal === "Add Combo Screen/Shade" ? "Combo" : ""}${(screenVal === "Add Shade" || screenVal === "Add Double Shade") ? "Shade" : ""} Mesh Color`,
                          )}
                        >
                          <Choices
                            label={state.label}
                            variant={
                              state.label === shadeMeshColor
                                ? "filled"
                                : "outlined"
                            }
                            checkMark={state.label === shadeMeshColor}
                          />
                        </div>
                      ))}
                    </RowLayout>
                  </div>
                )}

                <div
                  style={
                    screenVal === "Add Screen" ||
                    screenVal === "Add Combo Screen/Shade" ||
                    screenVal === "Add Shade" ||
                    screenVal === "Add Double Shade"
                      ? {
                          marginBottom: 10,
                          marginTop: 20,
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          borderLeft: `2px solid ${theme.palette.divider}`,
                          padding: theme.spacing(1, 2),
                        }
                      : {
                          marginBottom: 10,
                          marginTop: 20,
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                        }
                  }
                >
                  <Typography variant="subtitle1">
                    {screenVal === "Add Combo Screen/Shade" && "Combo "}
                    {(screenVal === "Add Screen" ||
                      screenVal === "Add Double Screen") &&
                      "Screen "}
                    {(screenVal === "Add Shade" ||
                      screenVal === "Add Double Shade") &&
                      "Shade "}
                    Extrusion Color
                    <span style={{ color: "red", fontSize: 22 }}>*</span>
                  </Typography>

                  <RowLayout>
                    {screenColors.map((state) => (
                      <div
                        key={state.id}
                        onClick={handleClick(
                          state.label,
                          screenLayout || "",
                          "screenColor",
                          `${screenVal === "Add Combo Screen/Shade" ? "Combo" : ""}${(screenVal === "Add Screen" || screenVal === "Add Double Screen") ? "Screen" : ""}${(screenVal === "Add Shade" || screenVal === "Add Double Shade") ? "Shade" : ""} Extrusion Color`,
                        )}
                      >
                        <Choices
                          label={state.label}
                          variant={
                            state.label === screenColorChoice
                              ? "filled"
                              : "outlined"
                          }
                          checkMark={state.label === screenColorChoice}
                        />
                      </div>
                    ))}
                  </RowLayout>
                </div>
              </RowLayout>

              {displayedImage &&
                screenLayoutImages
                  .filter((image) => image.label === displayedImage)
                  .map((imageShown) => (
                    <RowLayout key={imageShown.label}>
                      <ColLayout
                        style={{
                          marginRight: 40,
                          marginTop: 10,
                          marginBottom: 5,
                        }}
                      >
                        <Image
                          cloudName="ag-millworks"
                          secure="true"
                          publicId={imageShown.img}
                        />
                        <Typography
                          style={{ alignSelf: "center" }}
                          variant="caption"
                        >
                          *As viewed from exterior
                        </Typography>
                      </ColLayout>

                      {shadeMeshColor && hasShade && (
                        <div style={{ marginTop: -10 }}>
                          <Image
                            cloudName="ag-millworks"
                            secure="true"
                            publicId={`Shade_Colors/${shadeMeshColor
                              .split(" ")
                              .join("_")}_v2`}
                          >
                            <Transformation height="220" crop="scale" />
                          </Image>
                        </div>
                      )}
                    </RowLayout>
                  ))}
            </>
          )}
        </ColLayout>
      )}
    </ReusableAccordian>
  );
};

export default memo(CentorScreenAccordian);
